import https from "../init/https";

//QB-TX-01: Retrieve List of Taxonomies
export async function fetchTaxonomy(){
    const fetchTaxonomyData = await https.get(`/taxonomies`);
    return fetchTaxonomyData;
}